import script from "./UsuarioPerfil.vue?vue&type=script&setup=true&lang=js"
export * from "./UsuarioPerfil.vue?vue&type=script&setup=true&lang=js"

import "./UsuarioPerfil.vue?vue&type=style&index=0&id=118dc4df&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-118dc4df"]])

export default __exports__